import mediaFragment from './mediaFragment'

export default `
  id
  handle
  globalHandle
  locale
  pimSyncSourceDomain
  pimSyncSource
  pimSyncSourceCollectionId
  title
  description
  featuredMedia {
    ${mediaFragment}
  }
  productLists {
    title
    slug
    locale
    handles
  }
`
